import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { storeRegistry } from '@/store/storeRegistry'


export const useMessageStore = defineStore('messages', () => {
  const initialMessages: any = {
    logOutMessages: [],
    loggedInMessages: []
  }

  const messages = reactive({ ...initialMessages })

  function resetMessages() {
    Object.assign(messages, {
      logOutMessages: [],
      loggedInMessages: []
    })
  }

  function saveToCacheStore(data: any) {
    messages.loggedInMessages = data.messages;
  }

  function resetStore() {
    resetMessages()
  }

  storeRegistry.register('messages', resetStore)

  return { messages, resetMessages, saveToCacheStore, resetStore }
})
